module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-SKYPE.4c350797.png";